module.exports = __webpack_public_path__ + "img/percentage.23a1e84b.svg";